import {checkToken} from "@/utils/lambdaUtils.js";
import {useAuthStore} from "@/stores/authStore.js";
import axios from "axios";

const baseUrl = import.meta.env.VITE_APP_API_BASE_URL + "/s3";

export const getPreSignedDownloadUrl = async (fileName) => {
    await checkToken();
    const authStore = useAuthStore();

    const headers = {
        headers: {
            'Authorization': `Bearer ${authStore.token}`,  // Include token in the header
            'Content-Type': 'application/json'  // Set content type
        }
    };

    // Get the pre-signed URL from the server for the download
    try {
        const response= await axios.get( baseUrl + `/downloadS3File/${fileName}`, headers);
        if (response.data && response.data) {
            return response.data;
        } else {
            throw new Error("Unable to get signed download URL. Please try again later.");
        }
    } catch (error) {
        throw new Error (error.message);
    }
};